/* eslint-disable @typescript-eslint/no-explicit-any */
import L from "leaflet";

declare module "leaflet" {
  interface TileLayer {
    id?: string;
  }
}

type AddLayerProps = {
  id: string;
  map: L.Map;
  url: string;
  pane: string;
  zIndex: number;
  opacity: number;
  wmts: boolean;
};

export const addOrtofoto = ({
  id,
  map,
  url,
  pane,
  zIndex,
  opacity,
  wmts
}: AddLayerProps): L.Layer => {
  const [urlBase, queryString] = url.split("?");
  const urlParams = new URLSearchParams(queryString);

  if (wmts) {
    const serviceUrlParams: Record<string, any> = {
      style: "",
      tilematrixset: "WebMercatorQuad",
      Version: "1.0.0",
      Format: "image/png",
      Request: "GetTile",
      transparent: true,
      Service: "WMTS",
      TileMatrix: "{z}",
      TileCol: "{x}",
      TileRow: "{y}"
    };

    for (const [key, value] of Array.from(urlParams.entries())) {
      serviceUrlParams[key] = value;
    }

    const params = Object.entries(serviceUrlParams)
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    const serviceUrl = `${urlBase}?${params}`;

    const layerAdded = L.tileLayer(serviceUrl, {
      maxZoom: 24,
      tileSize: 256,
      zIndex: zIndex,
      pane: pane,
      opacity: opacity,
      attribution: "Ortofoto EGL © 2022"
    });

    layerAdded.id = id;

    layerAdded.addTo(map);

    return layerAdded;
  }

  const layers = urlParams.get("layers");
  const layerAdded = L.tileLayer.wms(urlBase, {
    layers: layers || "",
    format: "image/png",
    transparent: true,
    version: "1.3.0",
    maxZoom: 24,
    tileSize: 256,
    zIndex: zIndex,
    pane: pane,
    opacity: opacity,
    attribution: "Ortofoto EGL © 2022"
  });

  layerAdded.id = id;

  layerAdded.addTo(map);

  return layerAdded;
};
